// Build SEO-friendly doctor URLs like /doctor/ishtiaq-ali-6
export function slugify(text) {
  return String(text || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-") // non-alphanumerics -> dash
    .replace(/^-+|-+$/g, "");     // trim leading/trailing dashes
}

export function doctorSlug(doctor) {
  if (!doctor) return "";
  const id = doctor.id ?? doctor.doctor_id ?? "";
  const name = slugify(doctor.name);
  return name ? `${name}-${id}` : `${id}`;
}

// Extract the numeric id from a slug param (…-6 -> "6"; plain "6" -> "6")
export function parseDoctorId(param) {
  const match = String(param || "").match(/(\d+)\s*$/);
  return match ? match[1] : String(param || "");
}
